import React, { useContext, useState, useEffect } from 'react';
import ReactModal from 'react-modal';
import { AppContext } from '../../providers/AppContext';
import { AddBroadsider, Avatar, BroadsiderInfo, BroadsiderTraits, IconButton } from '../../components';
import { theme } from '../../theme';
import { openUrl } from '../../utils'; 
import { StyledBroadsiderSelectorModal } from './BroadsiderSelectorModal.styled';
import { BROADSIDER_COLLECTION_URL, BROADSIDER_OG_COLLECTION_URL } from '../../constants';

const BroadsiderSelectorModal = () => {
  const { setShowSelector, selectedBroadsider, ownedBroadsiders, selectBroadsider, setShowUpload } = useContext(AppContext);
  const [hoveredBroadsider, setHoveredBroadsider] = useState(null);
  const showingSelected = (selectedBroadsider ? selectedBroadsider.getId() : null) === (hoveredBroadsider ? hoveredBroadsider.getId() : null);
  const hoveredId = hoveredBroadsider ? hoveredBroadsider.getId() : null;

  useEffect(() => {
    if (selectedBroadsider) {
      setHoveredBroadsider(selectedBroadsider);
    }
  }, [selectedBroadsider]);

  const onShowOpensea = () => {
    if (!hoveredBroadsider) return;
    openUrl(hoveredBroadsider.getOpenSeaLink());
  };

  const onAddNew = () => {
    //openUrl(BROADSIDER_OG_COLLECTION_URL);
    setShowSelector(false);
    setShowUpload(true);
  };

  return (
    <StyledBroadsiderSelectorModal>
      <div className='selector-contents'>
      <div className='selector-decorator' />
      <div className='selector-background'>
        <div className='selector-title-holder'>
	  <div className='selector-title'>My Avatars:</div>
	  <div className='selector-title' style={{color: theme.selection}}>{ownedBroadsiders.length}</div>
        </div>
        <div className='selector-avatars-holder'>
          {ownedBroadsiders.map((f, index) => (<Avatar onMouseEnter={() => setHoveredBroadsider(f)} key={'selec' + index} figure={f} isSelected={f.getId() === selectedBroadsider.getId()} onClick={(figure) => selectBroadsider(figure)} isHovered={hoveredId === f.getId()}/>))}
	  <AddBroadsider onClick={onAddNew}/>
        </div>
        <div className='selector-traits-holder'>
          <div className='selector-traits-decorator' style={{ background: showingSelected ? theme.selection : 'white' }}/>
          <div className='selector-broadsider-info'>
            <BroadsiderInfo broadsider={hoveredBroadsider} />
          </div>
	  <BroadsiderTraits traits={hoveredBroadsider ? hoveredBroadsider.getTraits() : []} />
        </div>
        <div className='selector-opensea-button-holder'>
	  <IconButton disabled={!hoveredBroadsider || !hoveredBroadsider.isReal()} onClick={onShowOpensea}>
	    <div className='selector-opensea-button-content'>
	      <div>Show on Opensea</div>
	      <img style={{paddingBottom: '6px'}} src='/assets/arrow.svg'/>
	    </div>
	  </IconButton>
	</div>
      </div>
      </div>
      <div className='selector-corner selector-corner-tl' />
      <div className='selector-corner selector-corner-tr' />
      <div className='selector-corner selector-corner-bl' />
      <div className='selector-corner selector-corner-br' />
    </StyledBroadsiderSelectorModal>
  );
};

export default BroadsiderSelectorModal;
